<template>
  <div class="form-group"
       :class="form_group_class">
    <label v-if="label"
           :for="id">{{ label }}</label>
    <select ref="input"
            :class="'form-control ' + (size ? 'form-control-' + size : '')"
            :id="id"
            v-model="selected"
            @change="handleChange">
      <option v-for="(option, i) in options"
              :key="i"
              :value="option.value.join(',')">
        {{ option.name }}
      </option>
    </select>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "FlashBoxSizeSelector",
  props: {
    id: {
      type: String,
      required: true,
    },

    label: {
      type: String,
    },

    value: {
      type: null,
    },

    form_group_class: {
      type: String,
      default: "",
    },

    size: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      selected: null,
      options: [
        { name: "A3 (12*17 นิ้ว)", value: [12, 17, 1] },
        { name: "Mini (14*20*6 ซม.)", value: [14, 20, 6] },
        { name: "S (20*30*10 ซม.)", value: [20, 30, 10] },
        { name: "S+ (24*37*14 ซม.)", value: [24, 37, 14] },
        { name: "M (27*43*20 ซม.)", value: [27, 43, 20] },
        { name: "10*14*6 ซม.", value: [10, 14, 6] },
        { name: "11*17*6 ซม.", value: [11, 17, 6] },
        { name: "11*17*12 ซม.", value: [11, 17, 12] },
        { name: "14*20*6 ซม.", value: [14, 20, 6] },
        { name: "22*35*14 ซม.", value: [22, 35, 14] },
        { name: "24*40*17 ซม.", value: [24, 40, 17] },
        { name: "30*45*20 ซม.", value: [30, 45, 20] },
        { name: "1*1*1 ซม.", value: [1, 1, 1] }
      ],
      defaultValue: "1,1,1",
    }
  },

  created() {

    console.log(this.authData);

    if (this.authData && this.authData.user.id === "user-dd8d6990-37c6-11f0-97bb-b7f2011e414e1747998770856") this.defaultValue = "20,30,10";
    else this.defaultValue = "1,1,1";

    console.log("created", this.value);
    this.selected = Array.isArray(this.value)
      ? this.value.join(",")
      : this.value || this.defaultValue;
  },

  methods: {
    handleChange() {
      this.updateValue();
    },

    updateValue() {
      if (this.selected === this.value) return;
      this.$emit("input", this.selected);
      console.log("emitted", this.selected);
    },
  },

  mounted() {
    if (!this.value) {
      this.updateValue();
    }
  },

  computed: {
    ...mapGetters("user", ["authData"]),
  },

  watch: {
    value(newValue) {
      console.log("Watch", newValue);
      const nextSelected = Array.isArray(newValue)
        ? newValue.join(",")
        : newValue || this.defaultValue;

      if (nextSelected === this.selected) return;
      this.selected = nextSelected;
    },
  },
};
</script>

<style scoped lang="scss"></style>
